module.exports = __webpack_public_path__ + "static/media/pledge.3d34a43a.png";